export default "__VITE_ASSET__Kxx_BdrS__"